import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[customerAppEquityPageData]',
  standalone: false
})
export class EquityPageDataDirective {
  viewContainerRef = inject(ViewContainerRef);
}
